<template lang="pug">
  span(v-if="readonly")
    span(class="vkb_nak_readonly_input") {{val}}
    money(class="vkb_nak_hidden_input" v-model="val" v-bind="vmoneyConfig" readonly="readonly")
  //- input(v-else v-model.lazy="val" v-money="vmoneyConfig" @blur="onBlur")
  money(v-else v-model="val" v-bind="vmoneyConfig" @blur.native="onBlur") {{val}}
</template>

<script>
import { Money, VMoney } from 'v-money';

export default {
  name: 'maskInput',
  components: {
    Money
  },
  directives: {money: VMoney},
  props: {
    value: {},
    readonly: Boolean,
    prefix: String,
    suffix: String,
    decimalSeparator: { type: String, default: ',' },
    thousandsSeparator: { type: String, default: '.' },
    decimals: Number,
    id: String,
    input: {
      type: Function,
      default: () => {}
    },
    hasError: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      val: this.value,
      vmoneyConfig: {
        decimal: this.decimalSeparator,
        thousands: this.thousandsSeparator,
        prefix: this.prefix,
        suffix: this.suffix,
        precision: this.decimals,
        masked: this.readonly,
        allowBlank: true,
      }
    };
  },
  computed: {
    inputClass() {
      return {'vkb_nak_mask-input': true, 'vkb_nak_mask-input--error': this.hasError};
    },
  },
  mounted() {
    this.callInput(this.val);
  },
  methods: {
    onBlur(event) {
      event.value = this.val;
      this.$emit('blur', event);
    },
    callInput(newValue) {
      if (typeof this.input === 'function') {
        setTimeout(() => {
          const numValue = parseFloat(newValue);
          this.input({ value: `${numValue}` === newValue ? numValue : newValue });
        }, 0);
      }
    },
  },
  watch: {
    val(newVal) {
      this.callInput(newVal);
    },
    value(newVal) {
      this.val = newVal;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/mask-input.vue